module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), (_vm.eventosDisponiveis.length > 0) ? _c('div', [_c('label', [_vm._v("Eventos")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solenizacao),
      expression: "solenizacao"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "profiles"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.solenizacao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.eventosDisponiveis), function(evento) {
    return _c('option', {
      domProps: {
        "value": evento
      }
    }, [_vm._v(_vm._s(evento.event))])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uib-tooltip": "Inclui um evento na tabela abaixo",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addEvent(_vm.solenizacao)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir Evento")])]) : _vm._e(), _vm._v(" "), (_vm.eventosTabela.length > 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "ng-table": "tableEvents"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.eventosTabela), function(evento, eventoIndex) {
    return _c('tbody', [_c('tr', {
      staticClass: "ng-table-group",
      attrs: {
        "ng-hide": "eventos.event === ''"
      }
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(evento.event))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-flat",
      attrs: {
        "type": "button",
        "ng-disabled": "!solemnizationCtrl.isNewAvaiable()",
        "ng-class": "{'btn-danger':solemnizationCtrl.approvalState!='VIEW_TYPE', 'btn-default':solemnizationCtrl.approvalState=='VIEW_TYPE'}"
      },
      on: {
        "click": function($event) {
          return _vm.onDelete(evento, eventoIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_c('ol', [_c('li', [_vm._v("A Convenente informará à FBB pelo e-mail fbb.imprensa@fbb.org.br, 30 dias antes da data de assinatura do convênio:\n        "), _c('ul', [_c('li', [_vm._v("Entidade convenente, responsável legal e contatos")]), _vm._v(" "), _c('li', [_vm._v("Objeto do convênio")]), _vm._v(" "), _c('li', [_vm._v("Data, local e horário provável do evento")]), _vm._v(" "), _c('li', [_vm._v("Autoridades precistas no cerimonial e nº de participantes")]), _vm._v(" "), _c('li', [_vm._v("Programação prévia e contatos da imprensa local")])])]), _c('li', [_vm._v("Informar no Assunto do e-mail: Nº e nome do Projeto - Assinatura de convênio")]), _vm._v(" "), _c('li', [_vm._v("A Convenente fará, obrigatoriamente, a cobertura fotográfica do evento, com uso de, no mínimo, um banner indicativo do investimento social da FBB"), _c('br'), _vm._v("\n        e enviará as fotos com resolução mínima 320 x 233 pixels ou o equivalente a 150 DPI, formato 12 x 10 cm, similar ou proporcional.\n      ")]), _vm._v(" "), _c('li', [_vm._v("No evento deverá participar funcionário do BB.")]), _vm._v(" "), _c('li', [_vm._v("Se possível, a Convenente fará a filmagem e/ou cobertura fotográfica de outras fases do convênio e divulgará em sua página na Internet.")]), _vm._v(" "), _c('li', [_vm._v("Após o evento, enviar foto para o e-mail descrito no item 1.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "30px"
    }
  }, [_vm._v("Valor Padrão (Após Criação):"), _c('br'), _vm._v("\n      Cifrato: Não\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_c('strong', [_vm._v("Tabela de Eventos Adicionados")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Ações")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5a44916!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/solenizacao.vue
// module id = 2064
// module chunks = 1